/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, { Fragment, useEffect, useState } from "react";
import { useFormik } from "formik";
import { Table } from "reactstrap";
import * as Yup from "yup";
import ICSelect from "../../../components/form/selectInput";
import _ from "lodash";
import Label from "../../../components/label";
import Button from "../../../components/button";
import IconButton from "../../../components/iconButton";
import ICCheckbox from "../../../components/form/checkbox";
import ICInput from "../../../components/form/input";
import Anchor from "../../../components/anchor";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  addConsultNoteTemplateApiRoute,
  deleteConsultNoteTemplateApiRoute,
  getConsultNoteTemplatesApiRoute
} from "../../../apiRoutes";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Modal from "../../../components/modal";
import AddConsultNoteTemplateForm from "../AddConsultNoteTemplateForm";
import { MakeAPICall } from "../../../apiCalls/common";
import { TYPE_SELECTION } from "../../../constants/helperConstants";

const DOCTOR_CONSULT_NOTE_TEMPLATE_TYPE = {
  IS_SMOKING_CESSATION: "IS_SMOKING_CESSATION",
  IS_MEDICINAL_CANNABIS: "IS_MEDICINAL_CANNABIS"
};

const PrescriptionTypeSelectionFrom = props => {
  const [selectedTreatmentTypes, setSelectedTreatmentTypes] = useState([]);
  const [isSubmitButtonVisible, setIsSubmitButtonVisible] = useState(true);
  const [disableTypeName, setDisableTypeName] = useState(false);
  const [showTemplateDeleteModal, setShowTemplateDeleteModal] = useState(false);
  const [selectedDelTemplate, setSelectedDelTemplate] = useState(null);
  const [templateSelectOpen, setTemplateSelectOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templatesList, setTemplatesList] = useState([]);
  const [showAddTemplateModal, setShowAddTemplateModal] = useState(false);
  const [showTextModal, setShowTextModal] = useState(false);
  const [modalText, setModalText] = useState("");
  const [apiCallParams, setApiCallParams] = useState(null);
  const formik = useFormik({
    initialValues: {
      typeName: "",
      drug: "",
      combinationTherapyType: "",
      followUpInDays: props.formState.followUpInDays,
      patientDetailsConfirmed: props.formState.patientDetailsConfirmed,
      additionalNoteForConsultNote: props.formState.additionalNoteForConsultNote,
      additionalNoteForPatient: props.formState.additionalNoteForPatient,
      saveTemplateCheckbox: props.formState.saveTemplateCheckbox,
      patientAttachedPDF: props.formState.patientAttachedPDF
    },
    validationSchema: Yup.object({
      typeName: Yup.string().required("Please select type"),
      combinationTherapyType: Yup.string().when("type", {
        is: "Combination Therapy",
        then: Yup.string().required("Please select option")
      }),
      drug: Yup.string().when("typeName", {
        is: "Prescribed Medication",
        then: Yup.string().required("Please select option")
      }).when("typeName", {
        is: "Vaping | e-Cigarettes",
        then: Yup.string().required("Please select option")
      }).when("combinationTherapyType", {
        is: "Prescribed Medication",
        then: Yup.string().required("Please select option")
      }).when("combinationTherapyType", {
        is: "Vaping | e-Cigarettes",
        then: Yup.string().required("Please select option")
      }),
      patientDetailsConfirmed: Yup.boolean().required("Please confirm the patient details").oneOf([true], "Please confirm the patient details"),
      additionalNoteForConsultNote: Yup.string().required("Please enter consult note details"),
      additionalNoteForPatient: Yup.string().required("Please enter additional details for patient"),
      followUpInDays: Yup.number().required("Please enter the follow up days").min(1, "Please enter the valid days"),
      patientAttachedPDF: Yup.string().when([], {
        is: () => getPDFs().length > 0,
        then: Yup.string().required("Please select the pamphlet")
      })
    }),
    onSubmit: (values) => {
      console.log("Handle submit: ", values);
      const dataObj = {
        typeName: formik.values.typeName,
        drug: formik.values.drug,
        combinationTherapyType: formik.values.combinationTherapyType
      };
      const isAlreadyIncluded = _.filter(selectedTreatmentTypes, (o) => {
        return o.typeName === dataObj.typeName && o.drug === dataObj.drug && o.combinationTherapyType === dataObj.combinationTherapyType;
      });

      if (isAlreadyIncluded.length) {
        return;
      }
      handleFormSubmit(dataObj);
      savePrescriptionType();
    }
  });

  function savePrescriptionType() {
    props.setFormState({
      followUpInDays: formik.values.followUpInDays,
      patientDetailsConfirmed: formik.values.patientDetailsConfirmed,
      additionalNoteForConsultNote: formik.values.additionalNoteForConsultNote,
      additionalNoteForPatient: formik.values.additionalNoteForPatient,
      saveTemplateCheckbox: formik.values.saveTemplateCheckbox,
      patientAttachedPDF: formik.values.patientAttachedPDF
    });
  }

  const handleFormSubmit = (formValues) => {
    props.addSelectedType([...selectedTreatmentTypes, formValues]);
  };

  const deleteSelectedType = (index) => {
    const newArray = selectedTreatmentTypes.filter((_, i) => i !== index);
    props.addSelectedType(newArray)
    setSelectedTreatmentTypes(newArray);
  };

  const toggleFormSubmitBtn = () => {
    const isCombinationTherapySelected = _.find(selectedTreatmentTypes, (o) => {
      return o.typeName === "Combination Therapy";
    });
    console.log("isCombinationTherapySelected: --> ", isCombinationTherapySelected)
    if (isCombinationTherapySelected) {
      setDisableTypeName(true);
      formik.setFieldValue('typeName', 'Combination Therapy');
      formik.values.typeName = 'Combination Therapy';
    } else if (!isCombinationTherapySelected && selectedTreatmentTypes.length) {
      setDisableTypeName(true);
    } else {
      setDisableTypeName(false);
    }
    setIsSubmitButtonVisible(true);
  };

  useEffect(() => {
    // if combination therapy selected then we won't allow to change the first option
    toggleFormSubmitBtn();
  }, [selectedTreatmentTypes]);

  useEffect(() => {
    formik.values.drug = "";
    formik.values.combinationTherapyType = "";
  }, [formik.values.typeName]);

  useEffect(() => {
    formik.values.drug = "";
  }, [formik.values.combinationTherapyType]);

  useEffect(() => {
    if (props.selectedType.length) {
      setSelectedTreatmentTypes(props.selectedType);
      formik.setFieldValue("typeName", undefined);
      formik.setTouched({ typeName: false });
      toggleFormSubmitBtn();
    }
  }, [props.selectedType]);

  useEffect(() => {
    getTemplatesList();
  }, []);

  function getSelection() {
    switch (props.assessmentData.assessmentType) {
      case "Medicinal Cannabis":
        return <ICSelect
          label=""
          placeholder="Select Type"
          id="typeName"
          name="typeName"
          className="auto-width"
          useId="_id"
          useValue="val"
          disabled={disableTypeName}
          items={[
            { _id: "Medicinal Cannabis", val: "Medicinal Cannabis" }
          ]}
          value={formik.values.typeName}
          onBlur={formik.handleBlur}
          handleChange={val => {
            formik.values.typeName = val;
            formik.setFieldValue("typeName", val);
            // formik.handleChange("typeName");
            // formik.handleChange("drugName");
          }}
          error={formik.touched.typeName && formik.errors.typeName ? true : false}
          helperText={
            formik.touched.typeName && formik.errors.typeName
              ? formik.errors.typeName
              : ""
          }
        />;

      default:
        return <ICSelect
          label=""
          placeholder="Select Type"
          id="typeName"
          name="typeName"
          useId="_id"
          useValue="val"
          className="auto-width"
          disabled={disableTypeName}
          items={[
            { _id: "Over-The-Counter", val: "Over-The-Counter" },
            { _id: "Prescribed Medication", val: "Prescribed Medication" },
            { _id: "Vaping | e-Cigarettes", val: "Vaping | e-Cigarettes" },
            { _id: "Combination Therapy", val: "Combination Therapy" }
          ]}
          value={formik.values.typeName}
          onBlur={formik.handleBlur}
          handleChange={val => {
            formik.values.typeName = val;
            formik.setFieldValue("typeName", val);
            // formik.handleChange("typeName");
            // formik.handleChange("drugName");
          }}
          error={formik.touched.typeName && formik.errors.typeName ? true : false}
          helperText={
            formik.touched.typeName && formik.errors.typeName
              ? formik.errors.typeName
              : ""
          }
        />;
    }
  }

  function getPDFs() {
    switch (props.assessmentData.assessmentType) {
      case "Medicinal Cannabis":
        return props.constants.instantSwitchAttachedMCPDFs || [];
      default:
        return props.constants.instantSwitchAttachedPDFs || [];
    }
  }

  function handleTemplateSelectChange(event) {
    setSelectedTemplate(event.target.value);
    if (templatesList.length > event.target.value - 1) {
      const template = JSON.parse(templatesList[event.target.value - 1].note);

      Object.entries(template).forEach(([key, value]) => {
        formik.setFieldValue(key, value);
      });
    }
  }

  function toggleAddTemplateModal() {
    setShowAddTemplateModal(!showAddTemplateModal);
  }

  function getTemplateType() {
    if (props.assessmentData?.assessmentType === "Medicinal Cannabis") {
      return DOCTOR_CONSULT_NOTE_TEMPLATE_TYPE.IS_MEDICINAL_CANNABIS;
    }

    if (props.assessmentData?.assessmentType === "Smoking Cessation") {
      return DOCTOR_CONSULT_NOTE_TEMPLATE_TYPE.IS_SMOKING_CESSATION;
    }

    return undefined;
  }

  function getTemplatesList() {
    setApiCallParams({
      reqType: "GET",
      reqURL: getConsultNoteTemplatesApiRoute,
      params: { doctorId: props.auth.userData._id, templateType: getTemplateType() },
      successCallback: res => {
        setTemplatesList(res.data.data);
      },
      failureCallback: err => {
      }
    });
  }

  function saveNoteTemplate(templateName) {
    toggleAddTemplateModal();
    const formData = new FormData();
    formData.append("doctorId", props.auth.userData?._id);
    formData.append("templateName", templateName);
    formData.append("templateType", getTemplateType());
    formData.append("note", JSON.stringify({
      additionalNoteForPatient: formik.values.additionalNoteForPatient,
      additionalNoteForConsultNote: formik.values.additionalNoteForConsultNote,
    }));
    setApiCallParams({
      reqType: "POST",
      reqURL: addConsultNoteTemplateApiRoute,
      dataObj: formData,
      successCallback: res => {
        console.log({ res });
        setModalText("Template Saved Successfully");
        setShowTextModal(true);
        formik.setFieldValue("saveTemplateCheckbox", false);
        getTemplatesList();
      },
      failureCallback: err => {
        console.log({ err });
        formik.setFieldValue("saveTemplateCheckbox", false);
      }
    });
  }

  function setDelNoteTemplate(templateId) {
    setSelectedDelTemplate(templateId);
    setTemplateSelectOpen(false);
    setShowTemplateDeleteModal(true);
  }

  function deleteNoteTemplate() {
    setShowTemplateDeleteModal(false);

    if (selectedDelTemplate !== null) {
      let formData = new FormData();
      formData.append("templateId", selectedDelTemplate);

      setApiCallParams({
        reqType: "DELETE",
        reqURL: deleteConsultNoteTemplateApiRoute,
        dataObj: formData,
        successCallback: res => {
          setModalText("Template Deleted Successfully");
          setShowTextModal(true);
          setSelectedDelTemplate(null);
          getTemplatesList();
        },
        failureCallback: err => {
          setSelectedDelTemplate(null);
        }
      });
    }
  }

  const handleTemplateSelectOpen = () => {
    setTemplateSelectOpen(true);
  };

  const handleTemplateSelectClose = () => {
    setTemplateSelectOpen(false);
  };

  return (
    <Fragment>
      <Label className="secondary-font pl-2 pt-2" title="Select Treatment Plan" />
      <form className="row p-0 m-0" onSubmit={formik.handleSubmit}>
        {
          isSubmitButtonVisible && (
            <Fragment>
              <div className="col-sm-12 px-4">
                <FormControl className="w-100 mb-3 ic-custom-select">
                  <InputLabel>Select Template</InputLabel>
                  <Select
                    open={templateSelectOpen}
                    onClose={handleTemplateSelectClose}
                    onOpen={handleTemplateSelectOpen}
                    value={selectedTemplate}
                    onChange={handleTemplateSelectChange}
                  >
                    <MenuItem disabled value="">
                      Select Template
                    </MenuItem>
                    {templatesList.map((item, index) => (
                      <MenuItem value={index + 1}>
                        <div className="w-100 d-flex flex-row justify-content-between align-items-center">
                          <span>{item.templateName}</span>
                          {selectedTemplate !== index + 1 && (
                            <button
                              onClick={e => {
                                e.preventDefault();
                                e.stopPropagation();
                                setDelNoteTemplate(item._id);
                              }}
                              type="button"
                              className="btn btn-out-delete ml-2"
                            >
                              <i className="fas fa-trash-alt"></i>
                            </button>
                          )}
                        </div>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className={
                formik.errors.patientDetailsConfirmed
                  ? "col-sm-12 custom-chk-lbl pl-4 chk-error"
                  : "col-sm-12 custom-chk-lbl pl-4"
              }
              >
                <ICCheckbox
                  style={{ paddingRight: "5px" }}
                  name="patientDetailsConfirmed"
                  value={formik.values.patientDetailsConfirmed}
                  className="font-12 pl-3"
                  inputProps={{
                    "aria-label":
                      "Patient ID, DOB and address confirmed"
                  }}
                  label="Patient ID, DOB and address confirmed"
                  onChange={e => {
                    formik.setFieldValue("patientDetailsConfirmed", e.currentTarget.checked);
                  }}
                />
              </div>
              <div className="container-fluid mt-3 ml-0">
                <div className="row p-0 m-0">
                  <div className="col-sm-6 pt-1">
                    <Label title="Additional Information for Consult Note" className="secondary-font w-100" required={true} />
                  </div>
                </div>
                <div className="col-sm-12 pt-2 pb-4 mt-1">
                  <ICInput
                    id="additionalNoteForConsultNote"
                    name="additionalNoteForConsultNote"
                    className="text-area"
                    label=""
                    multiline
                    rows="3"
                    onChange={(event) => {
                      formik.setFieldValue("additionalNoteForConsultNote", event.target.value);
                      props.setFormState({
                        additionalNoteForConsultNote: event.target.value
                      });
                    }}
                    value={formik.values.additionalNoteForConsultNote}
                    error={formik.touched.additionalNoteForConsultNote && formik.errors.additionalNoteForConsultNote ? true : false}
                    helperText={
                      formik.touched.additionalNoteForConsultNote && formik.errors.additionalNoteForConsultNote
                        ? formik.errors.additionalNoteForConsultNote
                        : ""
                    }
                  />
                </div>
              </div>

              <div className="container-fluid mb-2 ml-0">
                <div className="row p-0 m-0">
                  <div className="col-sm-6 pt-1">
                    <Label title="Additional Information for Patient" className="secondary-font w-100" required={true} />
                  </div>
                </div>
                <div className="col-sm-12 pt-2 pb-4 mt-1">
                  <ICInput
                    id="additionalNoteForPatient"
                    name="additionalNoteForPatient"
                    className="text-area"
                    label=""
                    multiline
                    rows="3"
                    onChange={(event) => {
                      formik.setFieldValue("additionalNoteForPatient", event.target.value);
                      props.setFormState({
                        additionalNoteForPatient: event.target.value
                      });
                    }}
                    value={formik.values.additionalNoteForPatient}
                    error={formik.touched.additionalNoteForPatient && formik.errors.additionalNoteForPatient ? true : false}
                    helperText={
                      formik.touched.additionalNoteForPatient && formik.errors.additionalNoteForPatient
                        ? formik.errors.additionalNoteForPatient
                        : ""
                    }
                  />
                </div>
              </div>
              <div className="col-sm-12 px-4 custom-chk-lbl d-flex justify-content-end">
                <ICCheckbox
                  style={{ padding: "0 5px" }}
                  name="saveTemplateCheckbox"
                  onBlur={formik.handleBlur}
                  value={formik.values.saveTemplateCheckbox}
                  className="font-12"
                  inputProps={{
                    "aria-label": "Save Template"
                  }}
                  label="Save Template"
                  onChange={e => {
                    formik.setFieldValue(
                      "saveTemplateCheckbox",
                      e.target.checked
                    );

                    if (e.target.checked === true) {
                      toggleAddTemplateModal();
                    }
                  }}
                  labelPlacement="start"
                />
              </div>

              <div className="col-sm-12 pt-2 pb-4 mt-1 ml-3">
                Follow-Up in <sup className="asterisk">*</sup>
                <ICInput
                  required={true}
                  className="mx-2 follow-up-in-days-input"
                  id="followUpInDays"
                  name="followUpInDays"
                  error={formik.errors.followUpInDays}
                  type="number"
                  min={1}
                  onChange={(event) => {
                    formik.setFieldValue("followUpInDays", event.target.value);
                  }}
                  value={formik.values.followUpInDays}
                />
                days
              </div>
              <div className="container-fluid mb-3">
                {
                  !!getPDFs()?.length && (
                    <div className="row p-0 m-0">
                      <div className="col-sm-4 mb-3">
                        <Label title="Select Pamphlet" className="w-100" required={true} />
                        <ICSelect
                          label=""
                          placeholder="Select Pamphlet"
                          id="patientAttachedPDF"
                          name="patientAttachedPDF"
                          useId="url"
                          useValue="name"
                          items={getPDFs()}
                          value={formik.values.patientAttachedPDF}
                          handleChange={val => {
                            formik.setFieldValue("patientAttachedPDF", val);
                          }}
                        />
                      </div>
                      <div className="col-sm-8 pl-2">
                        <Label title="View Pamphlet" className="w-100 mb-3" />
                        {getPDFs().map((value, index) => {
                          return (
                            <Anchor
                              className={index === 0 ? "insta-link-orange font-14" : "insta-link-orange ml-4 font-14"}
                              key={index} title={value.name} href={value.url} target="_blank" />
                          );
                        })}
                      </div>
                    </div>
                  )
                }

                <div className="col-sm-4">
                  <Label className="gray small w-100" title="Select Type" required={true} />
                  {getSelection()}
                  {formik.errors.typeName && formik.touched.typeName ? (
                    <Label title="Please select type" className="small error w-100" />
                  ) : (
                    ""
                  )}
                </div>

                {
                  formik.values.typeName === "Combination Therapy" && (
                    <div className="col-sm-4">
                      <Label className="gray small w-100" title="Select Type" required={true} />
                      <ICSelect
                        label=""
                        placeholder="Select Type"
                        id="combinationTherapyType"
                        name="combinationTherapyType"
                        className="auto-width"
                        useId="_id"
                        useValue="val"
                        items={[
                          { _id: "Over-The-Counter", val: "Over-The-Counter" },
                          { _id: "Prescribed Medication", val: "Prescribed Medication" },
                          { _id: "Vaping | e-Cigarettes", val: "Vaping | e-Cigarettes" }
                        ]}
                        value={formik.values.combinationTherapyType}
                        onBlur={formik.handleBlur}
                        handleChange={val => {
                          formik.values.combinationTherapyType = val;
                          formik.setFieldValue("combinationTherapyType", val);
                          // formik.handleChange("combinationTherapyType");
                        }}
                        error={formik.touched.combinationTherapyType && formik.errors.combinationTherapyType ? true : false}
                        helperText={
                          formik.touched.combinationTherapyType && formik.errors.combinationTherapyType
                            ? formik.errors.combinationTherapyType
                            : ""
                        }
                      />
                      {formik.errors.combinationTherapyType && formik.touched.combinationTherapyType ? (
                        <Label title="Please select type" className="small error w-100" />
                      ) : (
                        ""
                      )}
                    </div>
                  )
                }
                {
                  (formik.values.typeName === "Vaping | e-Cigarettes" || formik.values.combinationTherapyType === "Vaping | e-Cigarettes") && (
                    <div className="col-sm-4">
                      <Label className="gray small w-100" title="Select Drug" required={true} />
                      <ICSelect
                        label=""
                        placeholder="Select Drug"
                        id="drug"
                        name="drug"
                        useId="_id"
                        useValue="val"
                        className="auto-width"
                        items={[
                          { _id: "Nicovape", val: "Nicovape" },
                          { _id: "Allo Sync", val: "Allo Sync" },
                          { _id: "Veev", val: "Veev" },
                          { _id: "Lula", val: "Lula" },
                          { _id: "Wild by Instinct", val: "Wild by Instinct" }
                        ]}
                        value={formik.values.drug}
                        onBlur={formik.handleBlur}
                        handleChange={val => {
                          formik.values.drug = val;
                          formik.setFieldValue("drug", val);
                          // formik.handleChange("drug");
                        }}
                        error={formik.touched.drug && formik.errors.drug ? true : false}
                        helperText={
                          formik.touched.drug && formik.errors.drug
                            ? formik.errors.drug
                            : ""
                        }
                      />
                      {formik.errors.drug && formik.touched.drug ? (
                        <Label title="Please select drug" className="small error w-100" />
                      ) : (
                        ""
                      )}
                    </div>
                  )
                }

                {
                  (formik.values.typeName === "Prescribed Medication" || formik.values.combinationTherapyType === "Prescribed Medication") && (
                    <div className="col-sm-4">
                      <Label className="gray small w-100" title="Select Drug" required={true} />
                      <ICSelect
                        label=""
                        placeholder="Select Drug"
                        id="drug"
                        name="drug"
                        useId="_id"
                        useValue="val"
                        className="auto-width"
                        items={[
                          { _id: "Bupropion (Zyban)", val: "Bupropion (Zyban)" },
                          { _id: "Varenicline (Champix)", val: "Varenicline (Champix)" }
                        ]}
                        value={formik.values.drug}
                        onBlur={formik.handleBlur}
                        handleChange={val => {
                          formik.values.drug = val;
                          formik.setFieldValue("drug", val);
                          // formik.handleChange("drug");
                        }}
                        error={formik.touched.drug && formik.errors.drug ? true : false}
                        helperText={
                          formik.touched.drug && formik.errors.drug
                            ? formik.errors.drug
                            : ""
                        }
                      />
                      {formik.errors.drug && formik.touched.drug ? (
                        <Label title="Please select drug" className="small error w-100" />
                      ) : (
                        ""
                      )}
                    </div>
                  )
                }


                {
                  (!selectedTreatmentTypes.length || (selectedTreatmentTypes[0] && selectedTreatmentTypes[0]['typeName'] === TYPE_SELECTION.COMBINATION_THERAPY)) && (
                    <div className="col-sm-12 text-center mt-3">
                      <Button type="submit" className="ml-3" title="Add Selected Type" />
                    </div>
                  )
                }
              </div>
            </Fragment>
          )
        }
      </form>

      {
        selectedTreatmentTypes.length ? (
          <div className="row p-0 m-0 mt-4 selected-type-container">
            <div className="col-sm-12">
              <Table hover>
                <thead>
                  <tr>
                    <th>Selected Type</th>
                    <th>Selected Drug</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    selectedTreatmentTypes.map((selectedType, index) => {
                      return (
                        <tr key={index}>
                          <td><Label
                            title={`${selectedType.typeName} ${selectedType.combinationTherapyType ? ("- " + selectedType.combinationTherapyType) : ""}`}
                            className="w-100 mb-0" /></td>
                          <td><Label title={`${selectedType.drug ? selectedType.drug : "-"}`} className="w-100" />
                          </td>
                          <td>
                            <IconButton
                              title=""
                              className="only-icon"
                              icon="fas fa-times"
                              clickEvent={() => deleteSelectedType(index)}
                            />
                          </td>
                        </tr>
                      );
                    })
                  }
                  <tr>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        ) : ("")
      }
      <Modal
        openModal={showAddTemplateModal}
        title="Add New Template"
        child={
          <AddConsultNoteTemplateForm
            cancelEvent={() => {
              formik.setFieldValue("saveTemplateCheckbox", false);
              toggleAddTemplateModal();
            }}
            onAddSubmit={saveNoteTemplate}
          />
        }
        noButtons={true}
      />
      <Modal
        title="Instant Consult"
        useOneButton={true}
        cancelText="Okay"
        openModal={showTextModal}
        cancelEvent={() => {
          setShowTextModal(false);
          setModalText("");
        }}
        child={<p className="text-center mb-0">{modalText}</p>}
      />
      <Modal
        openModal={showTemplateDeleteModal}
        child={
          <p className="text-center mb-0">
            Are you sure you want to delete this template?
          </p>
        }
        okayText="Yes"
        cancelText="No"
        title="Instant Consult"
        useOneButton={false}
        okayEvent={deleteNoteTemplate}
        cancelEvent={() => {
          setShowTemplateDeleteModal(false);
          setSelectedDelTemplate(null);
        }}
      />
      <MakeAPICall apiParam={apiCallParams} />
    </Fragment>
  );
};

const mapStateToProps = props => ({
  constants: props.auth.user.appConstant,
  auth: props.auth.user
});

export default connect(mapStateToProps, null)(withRouter(PrescriptionTypeSelectionFrom));
